<template>
  <div :class="classnames" v-external-click="datePickerClose">
    <label :class="`${ns}__bar`">
      <!-- <span :class="`${ns}__bar-label`">Date Range</span> -->
      <span :class="`${ns}__bar-field`">
        <button
          :class="`${ns}__bar-input`"
          :type="`text`"
          @click.prevent="filterToggleSelector(true)"
        >
          <span :class="`${ns}__bar-label--mobile`"><svg-icon-calendar />Date Range</span>
          <span v-if="!displayPredefinedRange">{{ displayFrom }} <span>–</span> {{ displayTo }}</span>
          <span v-else>{{ displayPredefinedRangeLabel }}</span>
        </button>
        <button :class="`${ns}__bar-button`"
        @click.prevent="filterToggleCalendars(true)"
        >
          <img src="../../assets/images/icon-cal.png" :class="`${ns}__bar-button-icon`"/>

        </button>
        <input
          :value="displayFrom"
          disabled
          hidden
          type="text"
        />
        <input
          :value="displayTo"
          disabled
          hidden
          type="text"
        />
      </span>
    </label>

    <div class="product-filter" :class="className">
      <!-- <div class="product-filter-button" id="datepicker">
        <div class="product-filter-button__title"
        >Date Range</div>
        <div class="product-filter-button__input--datepicker-track" @click="filterToggle(true)">
          <div class="product-filter-button__input--datepicker-item">
            <input type="text" class="product-filter-button__input product-filter-button__input--datepicker" disabled
            :value="displayFrom"
            >
          </div>
          <div class="product-filter-button__input--datepicker-item">
            <input type="text" class="product-filter-button__input product-filter-button__input--datepicker" disabled
            :value="displayTo"
            >
          </div>
          <div class="product-filter-button__input--datepicker-item">
            <i class="product-filter__icon"></i>
          </div>
        </div>
        <span class="product-filter__overlay"></span>
      </div> -->

      <!--
      <div class="product-filter-drop product-filter-drop--date product-filter-drop--selector">
        <div class="product-filter-select-holder">
          <select class="product-filter-select"
            @change="dateRangeSelectChange($event.target.value)"
          >
            <option value="">Custom Date Range</option>
            <option
              :key="option"
              v-for="option in Object.keys(customDateRangeOptions)"
              :value="option"
            >{{ option }}</option>
          </select>
        </div>
      </div>
      -->

      <div class="product-filter-drop product-filter-drop--date product-filter-drop--selector">
        <date-range-filter-combo-list
          :comparedMessage="comparedMessage"
          :selectedDateRange="selectedDateRange"
          :shouldShowUpgradeCta="shouldShowUpgradeCta"
          @optionclick="handleComboListOptionClick"
        />
      </div>

      <div class="product-filter-drop product-filter-drop--date product-filter-drop--calendars">
        <!-- <div class="product-filter-select-holder">
          <select class="product-filter-select"
            @change="dateRangeSelectChange($event.target.value)"
          >
            <option value="">Custom Date Range</option>
            <option
              :key="option"
              v-for="option in Object.keys(customDateRangeOptions)"
              :value="option"
            >{{ option }}</option>
          </select>
        </div> -->

        <div class="product-filter-picker">
          <div class="product-filter-picker-column product-filter-picker-column--start"
            v-if="pickerDateRange"
          >
            <input type="text" class="product-filter-picker__input product-filter-picker__input--start" disabled
              :value="'Starting: ' + dateDisplay(pickerDateRange.start)">
            <i class="product-filter__icon"></i>
          </div>
          <div class="product-filter-picker-column product-filter-picker-column--end"
            v-if="pickerDateRange"
          >
            <input type="text" class="product-filter-picker__input product-filter-picker__input--end" disabled
              :value="'Ending: ' + dateDisplay(pickerDateRange.end)">
            <i class="product-filter__icon"></i>
          </div>

          <div class="product-filter-calendar" :id="`calendar-${_uid}`"></div>
        </div>

        <div class="product-filter-picker-options">
          <div class="product-filter-picker-options__inner">
            <div class="product-filter-picker-options__section product-filter-picker-options__section--buttons">
              <div class="product-filter-picker-options__buttons">
                <button type="button" id="datepicker-reset" class="product-filter-picker__button product-filter-picker__button--reset"
                  @click.prevent="datePickerReset"
                >Reset</button>

                <button type="button" id="datepicker-apply" class="product-filter-picker__button product-filter-picker__button--apply"
                  @click.prevent="datePickerApplyClick"
                >Apply</button>
              </div>
            </div>

            <div v-if="shouldShowUpgradeCta" class="product-filter-picker-options__section product-filter-picker-options__section--upgrade">
              <div class="product-filter-picker-options__upgrade">
                <div class="product-filter-picker-options__upgrade-inner">
                  <p class="product-filter-picker-options__compared-message">{{ comparedMessage }}</p>
                  <!--
                  <p class="product-filter-picker-options__upgrade-text">Need more history?</p>
                  <div class="product-filter-picker-options__upgrade-cta">
                    <AnchorButton :appearance="`cta`">
                      <template slot="text">Upgrade</template>
                    </AnchorButton>
                  </div>
                  -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _find from 'lodash/find'
  import _findKey from 'lodash/findKey'
  import Kalendae from 'kalendae'
  import Moment from 'moment'
  import { extendMoment } from 'moment-range'

  import AnchorButton from '@/components/AnchorButton'
  import DateRangeFilterComboList from '@/components/DateRangeFilterComboList'

  import SvgIconCalendar from '@/svgs/SvgIconCalendar'

  import { bem } from '@/mixins/bem.js'
  import { helpers } from '@/mixins/helpers.js'
  import { getRanges, getRange } from '@/utils/dateRanges.js'
  import { EventBus } from '@/utils/eventBus.js'

  const namespace = 'date-range-filter'
  const moment = extendMoment(Moment)

  export default {
    name: 'DateRangeFilter',
    components: {
      AnchorButton,
      'date-range-filter-combo-list': DateRangeFilterComboList,
      'svg-icon-calendar': SvgIconCalendar
    },
    mixins: [ bem, helpers ],
    props: {
      className: {
        // default: '',
        type: String
      },
      dateRange: {
        required: true,
        type: Object
      },
      selectedDateRange: {
        type: String
      }
    },
    data: function () {
      return {
        calendar: '',
        dateRangeDefault: this.selectedDateRange,
        displayPredefinedRange: false,
        displayPredefinedRangeLabel: null,
        displayFrom: '',
        displayTo: '',
        pickerDateRange: null
      }
    },
    computed: {
      comparedMessage: function () {
        return 'Selected dates are compared to previous period.'
      },
      shouldShowUpgradeCta: function () {
        // NOTE
        // replace this with logic in the future
        // based on user privileges
        return true
      }
    },
    watch: {
      dateRange () {
        this.pickerDateRange = this.dateRange
        this.calendar.setSelected([this.pickerDateRange.start, this.pickerDateRange.end])
        this.updateDisplay()
      }
    },
    created: function () {
      this.namespace = namespace
    },
    mounted: function () {
      this.datePickerInit()

      const that = this

      EventBus.$on('tagfilterexpanded', function () {
        that.$el.classList.remove('tag-filter-collapsed')
        that.$el.classList.add('tag-filter-expanded')
      })

      EventBus.$on('tagfiltercollapsed', function () {
        that.$el.classList.remove('tag-filter-expanded')
        that.$el.classList.add('tag-filter-collapsed')
      })
    },
    methods: {
      dateDisplay (date) {
        return this.dateFormat(date, 'YYYY-MM-DD')
      },
      datePickerApplyClick () {
        this.datePickerApply()
      },
      datePickerApply (selectedDateRange = '') {
        this.updateDisplay()
        this.$emit('datePickerDateChange', this.pickerDateRange, selectedDateRange)
        this.filterToggleCalendars('close')
        this.filterToggleSelector('close')
      },
      datePickerClose () {
        // if (this.getBreakpoint() >= 768) {
        //   this.filterToggleCalendars('close')
        //   this.filterToggleSelector('close')
        // }

        this.filterToggleCalendars('close')
        this.filterToggleSelector('close')
      },
      datePickerInit () {
        let that = this

        // const _$calendar = document.getElementById(`calendar-${this._uid}`)
        // const _$kalendaes = _$calendar.childElementCount

        // if (_$kalendaes > 0) {
        //   if (typeof this.calendar !== 'string') {
        //     this.datePickerReset()
        //   }

        //   return
        // }

        // console.log('passed return catch')

        this.calendar = new Kalendae(`calendar-${this._uid}`, {
          direction: 'today-past',
          mode: 'range',
          months: 2,
          viewStartDate: moment(),
          blackout: function (date) {
            return date.isAfter(moment(), 'day') || date.isBefore(moment().subtract(2, 'year'), 'day')
          },
          subscribe: {
            change: function (date) {
              let dateArray = this.getSelectedAsDates()
              let end = typeof (dateArray[1]) !== 'undefined' ? dateArray[1] : dateArray[0]
              let start = dateArray[0]

              that.pickerDateRange = moment.range(
                moment(start).startOf('day'),
                moment(end).endOf('day')
              )

              if (that.dateRangeSelect()) {
                that.dateRangeSelect().value = ''
              }
              let option = _findKey(getRanges(), (range) => {
                const [
                  start,
                  end
                ] = range.array

                return start.isSame(that.pickerDateRange.start) && end.isSame(that.pickerDateRange.end)
              })
              if (option) {
                if (that.dateRangeSelect()) {
                  that.dateRangeSelect().value = option
                }
              }
            }
          }
        })

        this.datePickerReset()
      },
      datePickerReset () {
        this.dateRangeSelectChange(this.dateRangeDefault)

        const {
          from,
          to
        } = this.getSelectedRange()

        this.displayFrom = from
        this.displayTo = to

        // this.selectedDateRange = this.dateRangeDefault
      },
      dateRangeSelect () {
        let container = this.$el
        return container.querySelector('.product-filter-select')
      },
      dateRangeSelectChange (value) {
        if (typeof value === 'string' && value !== '') {
          let [start, end] = getRange(value).array

          this.calendar.setSelected([start, end])
        }
      },
      filterToggle (toggle, which) {
        let whichOne = which || 'calendars'

        let otherClasses = ['datepicker-active--calendars', 'active-toggle--calendars']

        if (whichOne === 'calendars') {
          otherClasses = ['datepicker-active--selector', 'active-toggle--selector']
        }

        let activeClass = ['datepicker-active', `datepicker-active--${whichOne}`]
        let activeToggle = ['active-toggle', `active-toggle--${whichOne}`]
        let container = this.$el
        // let target = container.querySelector(`.product-filter-drop--${whichOne}`)

        container.classList.remove(...otherClasses)

        if (toggle === true) {
          if (container.classList.contains(...activeToggle)) {
            container.classList.remove(...activeToggle)

            // if (this.getBreakpoint() < 768) {
            //   this.slideUp(target)
            // } else {
            //   container.classList.remove(...activeClass)
            // }

            container.classList.remove(...activeClass)
          } else {
            container.classList.add(...activeToggle)

            // if (this.getBreakpoint() < 768) {
            //   this.slideDown(target)
            // } else {
            //   container.classList.add(...activeClass)
            // }

            container.classList.add(...activeClass)
          }
        } else {
          if (toggle === 'close') {
            // if (container.classList.contains(...activeToggle)) {
            //   container.classList.remove(...activeToggle)

            //   if (this.getBreakpoint() < 768) {
            //     this.slideUp(target)
            //   }
            // }

            // if (this.getBreakpoint() >= 768) {
            //   container.classList.remove(...activeClass)
            // }

            container.classList.remove(...activeToggle)
            container.classList.remove(...activeClass)
          }

          if (toggle === 'open') {
            // if (!container.classList.contains(...activeToggle)) {
            //   container.classList.add(...activeToggle)

            //   if (this.getBreakpoint() < 768) {
            //     this.slideDown(target)
            //   }
            // }

            // if (this.getBreakpoint() >= 768) {
            //   container.classList.add(...activeClass)
            // }

            container.classList.add(...activeToggle)
            container.classList.add(...activeClass)
          }
        }
      },
      filterToggleCalendars (toggle) {
        this.filterToggle(toggle)
      },
      filterToggleSelector (toggle) {
        this.filterToggle(toggle, 'selector')
      },
      updateDisplay () {
        const {
          from,
          to
        } = this.getSelectedRange()

        this.displayFrom = from
        this.displayTo = to
      },
      getSelectedRange () {
        const dateFormat = 'MMM Do, YYYY'

        // let [
        //   from,
        //   to
        // ] = this.calendar.getSelectedRaw()

        // console.log('from')
        // console.dir(from)

        // console.log('from store')
        // console.dir(this.$store.state.ui.filterDateRange)

        let from = this.$store.state.ui.filterDateRange.start
        let to = this.$store.state.ui.filterDateRange.end

        // determine if we should display custom range
        let isPredefinedRange = false

        const ranges = getRanges()

        isPredefinedRange = _find(ranges, (range) => {
          const sFrom = from.format('MMM D, YYYY').toLowerCase()
          const sTo = to ? to.format('MMM D, YYYY').toLowerCase() : sFrom

          const value = range.value.toLowerCase()

          const hasFrom = value.indexOf(sFrom) !== -1
          const hasTo = value.indexOf(sTo) !== -1

          return hasFrom && hasTo
        })

        if (isPredefinedRange) {
          this.displayPredefinedRange = true
          this.displayPredefinedRangeLabel = isPredefinedRange.label
        } else {
          this.displayPredefinedRange = false
        }

        // or predefined text

        from = from.format(dateFormat)
        to = to ? to.format(dateFormat) : from

        return {
          from,
          to
        }
      },
      handleComboListOptionClick: function (option) {
        this.dateRangeSelectChange(option)
        this.datePickerApply(option)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/js/components/DateRangeFilter.vue